import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';

/**
 * Returns a default application display name based on the product
 * @param product
 */
export function getDefaultApplicationDisplayName(product: string) : string {
  switch (product) {
    case MojoWellKnownNames.Products.MojoDashboard:
      return 'Mojo';
    case MojoWellKnownNames.Products.Mci:
      return 'Mojo for Clients & Investors';
    case MojoWellKnownNames.Products.MojoForSuppliers:
      return 'Mojo for Suppliers';
    case MojoWellKnownNames.Products.MojoForTenants:
      return 'Mojo for Tenants';
    default:
      return '';
  }
}

